export default {
  hasIncidents: [
    { id: 'true', name: 'Yes' },
    { id: 'false', name: 'No' }
  ]
};
